import React from 'react';
import { createRoot } from 'react-dom/client';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import {
    Button, Col,
    Label, Input,
    Modal, ModalHeader, ModalBody, ModalFooter, Row
} from "reactstrap";


import * as commonFunc from 'scripts/common';
import CDataTable, { generateTable } from "components/CDataTable";

import CNavbar from 'components/CNavbar';

import Historical from "components/Historical";
import AGenerateModel from 'components/generic/AGenerateModel';

import moment from "moment";
import ToolbarDate from 'components/ToolbarDate';
import { FileUploadModal } from 'components/FilesCustom';

var modalRoot;

export default function SimpleListGeneric(props) {
    const { data, formManager, modelFctManager, accessList, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues } = formManager;

    const [shouldRender, setShouldRender] = React.useState(false);
    const [listStatus, setListStatus] = React.useState([]);
    const [curStatus, setCurStatus] = React.useState(0);
    const [dataRows, setDataRows] = React.useState([]);
    const [filteredRows, setFilteredRows] = React.useState([]);
    const [dataStamp, setDataStamp] = React.useState(0);
    const [curFilter, setCurFilter] = React.useState({});
    const [dtModel, setDtModel] = React.useState();
    const [dtFunctions, setDtFunctions] = React.useState();

    const [curDate, setCurDate] = React.useState(data.argumentsObj?.cStartDate || moment().format());
    const [endDate, setEndDate] = React.useState(data.argumentsObj?.cEndDate || moment().endOf("year").format());
    const [curPeriod, setCurPeriod] = React.useState(data.argumentsObj?.cStartPeriod || "L");

    const modalGenManager = React.createRef();

    var primKeyCptPath = data.argumentsObj?.paths?.primaryKey || "@@PRIMARY_KEY@@";
    var secKeyCptPath = data.argumentsObj?.paths?.secondaryKey || "@@SECONDARY_KEY@@";
    var getListCptPath = data.argumentsObj?.paths?.getList || "@@URL_GETLIST@@";
    var getStatusCptPath = data.argumentsObj?.paths?.getStatus || "@@URL_GETSTATUS@@";
    var saveListCptPath = data.argumentsObj?.paths?.saveList || "@@URL_SAVELIST@@";
    var rmvListCptPath = data.argumentsObj?.paths?.removeList || "@@URL_REMOVELIST@@";
    var getCptPath = data.argumentsObj?.paths?.get || "@@URL_GET@@";
    var addCptPath = data.argumentsObj?.paths?.add || "@@URL_ADD@@";
    var addSupCptPath = data.argumentsObj?.paths?.addSup || "@@URL_ADDSUP@@";
    var updCptPath = data.argumentsObj?.paths?.update || "@@URL_UPD@@";
    var updStatusCptPath = data.argumentsObj?.paths?.updateStatus || "@@URL_UPDSTATUS@@";
    var rmvCptPath = data.argumentsObj?.paths?.remove || "@@URL_RMV@@";
    var flowsCptPath = data.argumentsObj?.paths?.flows || "@@URL_FLOWS@@";
    var dlgAddCptPath = data.argumentsObj?.paths?.dlgAdd || "@@URL_DLGADD@@";
    var dlgUpdCptPath = data.argumentsObj?.paths?.dlgUpdate || "@@URL_DLGUPD@@";



    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        loadStatusBtnGrp();
        //getListData();

        return () => {
            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }
            if (data.argumentsObj.sidebarLocked) document.body.classList.remove("sidebar-locked");
        }
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    React.useEffect(() => {
        //console.debug(data);
        if (data.defaultValue) {
            if (systemItem[getListCptPath] && !(systemItem[getListCptPath].argumentsObj && systemItem[getListCptPath].argumentsObj.cPreventStartLoad)) {
                getListData();
            }
        }
        else {
            setDataRows([]);
            setFilteredRows([]);
            setDataStamp(0);
            if (!dtModel) getModel();
        }
    }, [data]);


    React.useEffect(() => {
        if (dataStamp > 0) getListData();
    }, [curStatus]);

    React.useEffect(() => {
        if (dataStamp > 0) getListData();
    }, [curPeriod, curDate, endDate]);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    data.functionManager.rerender = () => { setShouldRender(!shouldRender) };
    data.functionManager.clearModal = () => {
        return new Promise((resolve, reject) => {
            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }

            resolve({ isSuccess: true, result: true });
        });
    };
    data.functionManager.saveList = (dataExt) => { return saveList(dataExt); };
    data.functionManager.getGetListCpt = () => { return systemItem[getListCptPath]; };
    data.functionManager.getTableData = (onlySelected) => { return dtFunctions ? dtFunctions["tableGen" + data.subType].getData(onlySelected) : null; };
    data.functionManager.getTable = (onlySelected) => { return dtFunctions ? dtFunctions["tableGen" + data.subType].getTable() : null; };
    data.functionManager.refreshList = () => { getListData(); };
    data.functionManager.updateDataStamp = (datetime) => { setDataStamp(datetime || new Date().getTime()); };
    data.functionManager.loadList = (extList) => { loadDataRows(extList); };


    register(bindPropResult);

    var disabled = ((data.disabled ? true : false) || (!data.ignoreParentDisabled ? parentDisabled : false));

    function checkStatus(args, statusID) {
        var limitedAccessStatus = false;
        if (args) {
            var splitLimited = args.toString().split(";");
            if (splitLimited?.length) {
                var filtered = splitLimited.filter(status => parseInt(status) === parseInt(statusID));
                if (filtered?.length) limitedAccessStatus = true;
            }
        }
        return limitedAccessStatus;
    }

    var exclusionStatus = checkStatus(data.argumentsObj.cLimitedStatus, curStatus);

    var systemItem = accessList;//modelFctManager.onActionRequired(data.name, { trigger: "findFragment", target: data.src } , data).then(actionResponse => {
    //Info : data.subType echo à systemItem[secKeyCptPath].subType

    //Gestion bouton saveList variable
    if (data.argumentsObj?.cSaveListAltStatus) {
        if (Array.isArray(data.argumentsObj.cSaveListAltStatus)) {
            data.argumentsObj.cSaveListAltStatus.forEach((e, i) => {
                if (e.statusID) {
                    var updLimitedAccessStatus = checkStatus(e.statusID, curStatus);
                    if (updLimitedAccessStatus) saveListCptPath = e.saveListPath;
                }
            });
        }
        else {
            var updLimitedAccessStatus = checkStatus(data.argumentsObj.cSaveListAltStatus.statusID, curStatus);
            if (updLimitedAccessStatus) saveListCptPath = data.argumentsObj.cSaveListAltStatus.saveListPath;
        }
    }


    var primaryKey = commonFunc.camelize(systemItem[primKeyCptPath].value);
    var secondaryKey = commonFunc.camelize(systemItem[secKeyCptPath].value);

    var dtConfig = {
        columnDefs: [
            {
                createdCell: (td, cellData, rowData, row, col) => {
                    var currRoot = createRoot(td);

                    var supProp = {};
                    if (!data.argumentsObj?.cAlwaysPdf && !commonFunc.isBlank(cellData)) supProp.href = cellData;
                    else {
                        var managePdf = modelFctManager.checkRights("CUSTOM_FILES", "C");
                        if (managePdf) {
                            var actionPdf = ((e) => {
                                e.preventDefault();
                                var callbackModal = function (modalFiles) {
                                    //console.debug(modalFiles);

                                    //setFiles(modalFiles);
                                    var gFiles = [];
                                    if (modalFiles?.length) {
                                        if (!modalFiles[0].error) {
                                            var newFiles = gFiles;
                                            modalFiles.forEach(file => {
                                                //console.debug(file);
                                                if (file.responseData) newFiles.push(file.responseData.result);
                                            });

                                            var compFiles = newFiles;
                                            //console.debug(compFiles.length);
                                            if (compFiles.length === 1) {
                                                if (checkStatus(data.argumentsObj.cShowUpdStatus, rowData.statusID)) {//TODO : modif arguments
                                                    var altSavePath;
                                                    if (data.argumentsObj.cRollbackSaveList) altSavePath = data.argumentsObj.cRollbackSaveList
                                                    saveList({ rowId: secondaryKey, data: [rowData] }, altSavePath);
                                                }
                                            }
                                            else if (compFiles.length > 0) {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: t("gal_fail"),
                                                    html: t("gal_invalidFilesNb")
                                                });
                                            }
                                            gFiles = [];
                                            compFiles = [];
                                        }
                                        else {
                                            Swal.fire({
                                                icon: "error",
                                                title: t("gal_fail"),
                                                html: modalFiles[0].error
                                            });
                                        }
                                    }
                                    gFiles.length = 0;


                                    modalRoot.unmount();
                                };

                                modalRoot = createRoot(document.createElement('div'));
                                modalRoot.render(<FileUploadModal parentProps={{
                                    minFiles: 1, maxFiles: 1, uploadAutoClose: true, noChooseTypes: true, noUploads: false, accept: { "application/pdf": [".pdf"] },
                                    altFilesTypes: "../api/custom/GetCustomFilesType", altUploadFilesUrl: "../api/custom/UploadCustomFiles"
                                }} title={t("gal_filesTransfer")} defaultFileType={"LNK"} fileTypeID={"CUSTOM"} bindID={rowData[secondaryKey]}
                                    waitForCompletion={() => { return true; }} callback={callbackModal}></FileUploadModal>);
                            });

                            if (data.argumentsObj.cAlwaysPdf && !commonFunc.isBlank(cellData)) supProp.href = cellData;
                            else supProp.onClick = actionPdf;

                            supProp.onContextMenu = actionPdf;
                            supProp.title = t("dt_titleAltUploadPdf");
                            supProp.style = { cursor: "pointer" };
                        }
                    }

                    currRoot.render(<><div className='d-none'>{cellData}</div><div className='text-center'><a target='_blank' {...supProp} ><i className={`fa fa-file-pdf fa-2x ${supProp.href ? "" : "text-danger"}`} /></a></div></>);
                }, "targets": "renderingAltUploadPdf"
            },
            {
                createdCell: (td, cellData, rowData, row, col) => {
                    var currRoot = createRoot(td);

                    var showAddSup = false;
                    if (systemItem[addSupCptPath]) {
                        if (systemItem[addSupCptPath].argumentsObj?.cShowButton) {
                            var value = commonFunc.getValue(rowData, systemItem[addSupCptPath].argumentsObj.cShowButton);
                            showAddSup = commonFunc.isBlank(value);
                        }
                        else {
                            showAddSup = true;
                        }
                    }

                    var rightsObj = systemItem[addSupCptPath];
                    if (showAddSup && rightsObj.checkRights) {
                        showAddSup = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                    }
                    rightsObj = systemItem[updCptPath];
                    var updRights = true;
                    if (rightsObj && rightsObj.checkRights) {
                        updRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                    }
                    rightsObj = systemItem[updStatusCptPath];
                    var updStatusRights = true;
                    if (rightsObj && rightsObj.checkRights) {
                        updStatusRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                    }
                    rightsObj = systemItem[rmvCptPath];
                    var rmvRights = true;
                    if (rightsObj && rightsObj.checkRights) {
                        rmvRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                    }
                    rightsObj = systemItem[flowsCptPath];
                    var flowsRights = true;
                    if (rightsObj && rightsObj.checkRights) {
                        flowsRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
                    }
                    if (rightsObj && rightsObj.argumentsObj && rightsObj.argumentsObj.cShowButton) {
                        var value2 = commonFunc.getValue(rowData, rightsObj.argumentsObj.cShowButton);
                        flowsRights &= !commonFunc.isBlank(value2);
                    }

                    var onlyShowDialog = data.argumentsObj?.cOnlyShowDialog;


                    var renderSupFields = [];
                    var supFields = systemItem[getListCptPath];
                    if (supFields?.argumentsObj?.actionsSupFields && Object.keys(supFields.argumentsObj.actionsSupFields).length) {
                        renderSupFields.push(<><br /><br /></>);
                        Object.keys(supFields.argumentsObj.actionsSupFields).forEach((field) => {
                            var obj = supFields.argumentsObj.actionsSupFields[field];
                            //rowData[supFields]
                            var renderFunc = generateTable(obj.generateFunction, obj.generateArgs);
                            if (renderFunc) {
                                renderSupFields.push(renderFunc(cellData, null, rowData));
                            }
                            else {
                                renderSupFields.push(commonFunc.getValue(rowData, field) || "");
                            }
                        });
                    }
                    //Exclusion des boutons par le statut
                    var rowExclusionStatus = checkStatus(data.argumentsObj?.cLimitedStatus, rowData.statusID);
                    var rowExclusionStatusSup = checkStatus(data.argumentsObj?.cLimitedStatusSup, rowData.statusID);

                    var rowShowUpdStatus = checkStatus(data.argumentsObj?.cShowUpdStatus, rowData.statusID);

                    var showAdd = (!rowExclusionStatus && !onlyShowDialog && showAddSup);
                    var showEdit = (!rowExclusionStatus && !onlyShowDialog && !showAddSup && systemItem[updCptPath] && updRights);
                    var showEditAlt = (!rowExclusionStatus && onlyShowDialog);
                    var showStatus = (rowShowUpdStatus && !onlyShowDialog && systemItem[updStatusCptPath] && updStatusRights);
                    var showRemove = (!rowExclusionStatus && systemItem[rmvCptPath] && rmvRights);
                    var showFlowsBtn = (!(rowExclusionStatus && rowExclusionStatusSup) && systemItem[flowsCptPath] && flowsRights);

                    //Limiter l'affichage des boutons UPD par le statut
                    if (data.argumentsObj?.cUpdAccessStatus) {
                        var updLimitedAccessStatus = checkStatus(data.argumentsObj.cUpdAccessStatus, rowData.statusID);
                        if (!updLimitedAccessStatus) {
                            showEdit = false;
                            showEditAlt = false;
                        }
                    }

                    //Limiter l'affichage des boutons status si DSysMod
                    var statusCpt = systemItem[updStatusCptPath];
                    if (showStatus && statusCpt?.argumentsObj?.cLimitedTime) {
                        showStatus = moment().diff(moment(rowData.dSysMod).utc(true), "minutes") > statusCpt?.argumentsObj?.cLimitedTime;
                    }

                    var rbLabelStart = data.subType + "_rollback";
                    var rbLabelI18n = t(rbLabelStart);
                    var updsLabelStart = data.subType + "_updStatusBtn";
                    var updsLabelI18n = t(updsLabelStart);

                    currRoot.render(<>{showAdd ? <Button className='btn-icon m-0 me-1' disabled={disabled} color="success" size="sm"
                        onClick={() => { saveData(rowData[secondaryKey], rowData, true) }} title={t("gal_add")}><i className='fa fa-plus'></i></Button> : ""}
                        {showEdit ? <Button className='btn-icon m-0 me-1' disabled={disabled} color="primary" size="sm"
                            onClick={() => { saveData(rowData[secondaryKey], rowData) }} title={t("gal_edit")}><i className='fa fa-edit'></i></Button> : ""}
                        {showEditAlt ? <Button className='btn-icon m-0 me-1' disabled={disabled} color="secondary" size="sm"
                            onClick={() => { saveData(rowData[secondaryKey], rowData) }} title={t("gal_edit")}><i className='fa fa-eye'></i></Button> : ""}
                        {showStatus ? <Button className='btn-icon m-0 me-1' disabled={disabled} color="info" size="sm"
                            onClick={() => { updateStatus(rowData[secondaryKey], rowData) }} title={updsLabelI18n !== updsLabelStart ? updsLabelI18n : t("gal_status")}><i className='fa fa-forward-step'></i></Button> : ""}
                        {showStatus ? <Button className='btn-icon m-0 me-1' disabled={disabled} color="warning" size="sm"
                            onClick={() => {
                                var altSavePath;
                                if (data.argumentsObj?.cRollbackSaveList) altSavePath = data.argumentsObj?.cRollbackSaveList
                                saveList({ rowId: secondaryKey, data: [rowData] }, altSavePath);
                            }} title={rbLabelI18n !== rbLabelStart ? rbLabelI18n : t("gal_edit")}><i className='fa fa-sync-alt'></i></Button> : ""}
                        {showRemove ? <Button className='btn-icon m-0' disabled={disabled} color="danger" size="sm"
                            onClick={() => removeData(rowData[secondaryKey], rowData)} title={t("gal_remove")}><i className='fa fa-trash-alt'></i></Button> : ""}
                        {showFlowsBtn ? <Button className='btn-simple btn-icon m-0' disabled={disabled} color="dark" size="sm"
                            onClick={() => showFlows(rowData[secondaryKey], rowData)} title={t("gal_flows")}><i className='fa fa-clock-rotate-left'></i></Button> : ""}{renderSupFields.map((elem, index) => <span key={"slg" + index}>{elem}</span>)}</>);
                }, "targets": "renderingActions"
            },
        ],
        dtOnSelect: function (dataSel, table, rowSelected) {
            //triggerOnChange();

            //Annulation de la sélection si ligne exclu du système de sélection
            var excludeSelection = data.argumentsObj?.excludeSelection;
            if (excludeSelection && commonFunc.isBlank(dataSel[excludeSelection])) {
                rowSelected.deselect();
            }
        },
        dtOnUnselect: function (dataSel, table, rowUnselected) {
            //triggerOnChange();
        },
        dtOnDblClick: function (e, row) {
            var dataList = dtFunctions ? dtFunctions["tableGen" + data.subType]?.getData(true) : null;
            //var dataList = dtFunctions["tableGen" + data.subType].getData(false);
            if (data.onActionEvents?.extrasActionEvent && data.onActionEvents.extrasActionEvent["dblClickEvents"]?.length > 0) {
                data.onActionEvents.extrasActionEvent["dblClickEvents"].forEach((args, index) => {
                    if (args.value === "listValues") args.value = dataList?.data;
                    else if (args.value === "currValue") args.value = row.id();
                    else if (args.value.startsWith("pathValue:")) {
                        var rowData = row.data();
                        args.value = commonFunc.getValue(rowData, args.value.replace("pathValue:", ""));
                    }


                    modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        },
        cbRowCallback: function (rowNode, rowData) {
            //Cache la sélection si ligne exclu du système de sélection
            var excludeSelection = data.argumentsObj?.excludeSelection;
            if (excludeSelection && commonFunc.isBlank(rowData[excludeSelection])) {
                var firstChild = rowNode.getElementsByTagName("td")[0];
                firstChild.classList.remove("select-checkbox");
            }

            //Gestion de couleur des lignes
            var manageColor = data.argumentsObj?.manageColor;
            if (manageColor) {
                Object.keys(manageColor).forEach(key => {
                    var value = "";
                    var splitTag = key.split(";");
                    splitTag.forEach(tag => {
                        value += rowData[tag] + ";";
                    });
                    var color = manageColor[key][value];
                    if (color) {
                        if (color.startsWith("#") || color.startsWith("rgb")) {
                            rowNode.style.setProperty("background-color", color);
                        }
                        else {
                            rowNode.classList.add(color);
                        }
                    }
                });
            }
        }
    };


    function dtFunctionPanel(id, fctPanel) {
        var newFcts = dtFunctions || {};
        if (!newFcts[id]) newFcts[id] = {};
        newFcts[id] = fctPanel;
        setDtFunctions(newFcts);
    }

    function getModel() {
        if (data.argumentsObj.dtConfig) {
            modelFctManager.onActionRequired(data.name, { trigger: "getModel", value: data.argumentsObj.dtConfig }, data).then(actionResponse => {
                if (actionResponse.isSuccess) {
                    setDtModel(actionResponse.result);

                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: actionResponse.errorMessage
                    });
                }
            });
        }
    }

    function triggerOnChange(srcElem) {
        //TODO : récup listValues
        //TODO call triggerOnChange
        if (dtFunctions) {
            //console.debug(dtFunctions["tableGen" + data.subType]);
            var dataList = srcElem || dtFunctions["tableGen" + data.subType].getData(true);
            //var dataList = dtFunctions["tableGen" + data.subType].getData(false);

            if (data.onActionEvents && data.onActionEvents["onChange"]) {
                data.onActionEvents["onChange"].forEach((args, index) => {
                    if (args.value === "listValues") args.value = dataList.data || dataList;
                    else if (args.value === "status") args.altValue = curStatus;

                    modelFctManager.onActionRequired(data.name, args, data).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        }
    }

    function getListData(statusID) {
        setDataRows([]);
        setFilteredRows([]);
        setDataStamp(0);

        var args = {};
        var getlistItem = systemItem[getListCptPath];
        if (getlistItem && getlistItem.argumentsObj && Object.keys(getlistItem.argumentsObj).length) {

            if (!getlistItem.argumentsObj.noDialog) {
                Swal.fire({
                    title: t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });
            }

            if (!dtModel) getModel();

            Object.keys(getlistItem.argumentsObj).forEach((key) => {
                var valueArgs = getlistItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;

                //Récup du statut par défaut (soit valeur defaultArgs, soit celle en state)
                if (valueArgs === "curStatus") {
                    var defaultStatus = statusID || curStatus;
                    var getstatusItem = systemItem[getStatusCptPath];
                    if (!defaultStatus && getstatusItem && getstatusItem.argumentsObj && Object.keys(getstatusItem.argumentsObj).length) {
                        defaultStatus = getstatusItem.argumentsObj["defaultStatus"]
                    }
                    args[key] = defaultStatus;
                }
            });
            if (args.filters && (args.filterInput != null && args.filterInput !== undefined)) {
                if (!commonFunc.isBlank(args.filterInput)) {
                    args.filters = [...args.filters];
                    args.filters.push(args.filterInput);
                }
                delete args.filterInput;
            }

            var useDate = getlistItem.argumentsObj.cUseToolbarDate;
            var managePeriodCoeff = (recList) => { return recList; };
            if (useDate) {
                args.startDate = curDate;
                args.period = curPeriod;

                if (curPeriod === "C") {
                    args.startDate = moment(curDate).startOf("day").format();
                    args.endDate = moment(endDate).endOf("day").format();

                    var diffDays = moment(args.endDate).diff(moment(args.startDate), 'days');
                    var yearDaysCpt = (moment().isLeapYear() ? 366 : 365) -1;
                    var coeffPeriod = diffDays / yearDaysCpt;

                    managePeriodCoeff = (recList) => {
                        if (recList?.length && (recList[0]?.contractValue || recList[0]?.contractValue === 0)) {//TODO : check le cas du cache
                            recList.forEach((dataItem) => {
                                if (!dataItem.cPeriodConversion) {
                                    dataItem.contractValue = parseInt(dataItem.contractValue * coeffPeriod);
                                    if (dataItem.totalValue && dataItem.contractValue) dataItem.contractValuePercent = dataItem.totalValue / dataItem.contractValue;

                                    dataItem.cPeriodConversion = true;
                                }
                            });
                        }
                        return recList;
                    };
                }
            }


            if (getlistItem.argumentsObj.cUseCache && modelFctManager.rootCache && modelFctManager.rootCache[getlistItem.argumentsObj.cUseCache]) {
                loadDataRows(managePeriodCoeff(modelFctManager.rootCache[getlistItem.argumentsObj.cUseCache]));
            }
            else if (getlistItem.argumentsObj.useProp) {
                var list = [];
                var valueArgs = getlistItem.argumentsObj.useProp;
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) list = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else list = valueArgs;
                loadDataRows(managePeriodCoeff(list));
            }
            else {
                var url = "../" + getlistItem.argumentsObj.url;

                var callMethod = commonFunc.getMethod;
                if (getlistItem.argumentsObj.cMethod === "POST") callMethod = commonFunc.postMethod;

                callMethod(url, args).then((response) => {

                    if (response.data) {
                        if (response.data.isSuccess) {
                            if (response.data.extraInfo && response.data.extraInfo.isSuccess) {
                                if (getlistItem.argumentsObj.cUseCache) {
                                    modelFctManager.rootCache[getlistItem.argumentsObj.cUseCache] = response.data.extraInfo.result;
                                }
                                loadDataRows(managePeriodCoeff(response.data.extraInfo.result));
                            }
                            else if (Array.isArray(response.data.result)) {
                                if (getlistItem.argumentsObj.cUseCache) {
                                    modelFctManager.rootCache[getlistItem.argumentsObj.cUseCache] = response.data.result;
                                }
                                loadDataRows(managePeriodCoeff(response.data.result));
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    didOpen: () => { Swal.hideLoading() },
                                    html: t(data.subType + "_errorGetlist") + " :<br>" + response.data.errorMessage
                                });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                didOpen: () => { Swal.hideLoading() },
                                html: t(data.subType + "_errorGetlist") + " :<br>" + response.data.errorMessage
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(data.subType + "_errorGetlist")
                        });
                    }
                });
            }
        }
        else {
            if (!getlistItem) {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_errorCfg")
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    function loadDataRows(srcElem) {
        if (srcElem && srcElem.length && srcElem[0].extras) {
            srcElem.forEach((row) => {
                row.orgExtras = row.extras;
                row.extras = {};
                if (row.orgExtras && row.orgExtras.length) {
                    row.orgExtras.forEach((extra) => {
                        row.extras[extra.name] = extra.value;
                    });
                }
            });
        }
        if (srcElem && srcElem.length && srcElem[0].hasOwnProperty("custom")) {
            srcElem.forEach((row) => {
                if (row.custom) {
                    row.custom.orgExtras = row.custom.extras;
                    row.custom.extras = {};
                    if (row.custom.orgExtras && row.custom.orgExtras.length) {
                        row.custom.orgExtras.forEach((extra) => {
                            row.custom.extras[extra.name] = extra.value;
                        });
                    }
                }
            });
        }
        Swal.close();
        setDataRows(srcElem);
        setFilteredRows(filterData(curFilter, srcElem));
        setDataStamp(new Date().getTime());

        triggerOnChange(srcElem);
    }

    function filterData(localFilter, rows) {
        if (!rows) rows = dataRows;

        var filteredRows = rows.filter((row) => {
            var flag = true;
            Object.keys(localFilter).forEach((key) => {
                var filterObj = localFilter[key];
                var filterValue = filterObj.value;

                var rowVal = (commonFunc.isBlank(filterValue) && filterValue !== false) || commonFunc.getValue(row, key);
                if (!(commonFunc.isBlank(filterValue) && filterValue !== false) && filterObj.operator) {
                    switch (filterObj.operator) {
                        case "=": flag &= (rowVal === filterValue); break;
                        case "!=": flag &= (rowVal !== filterValue); break;
                        case "<": flag &= (rowVal < filterValue); break;
                        case "<=": flag &= (rowVal <= filterValue); break;
                        case ">": flag &= (rowVal > filterValue); break;
                        case ">=": flag &= (rowVal >= filterValue); break;
                        default: break;
                    }
                }
                else {
                    flag &= ((commonFunc.isBlank(filterValue) && filterValue !== false) || commonFunc.getValue(row, key) === filterValue);
                }
            });
            return flag;
        });

        return filteredRows;
    }

    function saveList(extData, altPath) {
        var savePath = (altPath || saveListCptPath);
        var saveItem = systemItem[savePath];
        var saveProcess = function () {
            Swal.fire({
                title: (t(data.subType + savePath + "_updProc") === (data.subType + savePath + "_updProc") ? (t(data.subType + "_updProc") === (data.subType + "_updProc") ? t("gal_saving") : t(data.subType + "_updProc")) : t(data.subType + savePath + "_updProc")),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            var args = {};
            if (saveItem && saveItem.argumentsObj && Object.keys(saveItem.argumentsObj).length) {
                var dataList = (extData ? extData : dtFunctions["tableGen" + data.subType].getData(saveItem.argumentsObj.onlySelected));

                var postData = dataList.data;
                if (!commonFunc.isBlank(saveItem.subType)) {
                    switch (saveItem.subType) {
                        case "keyItem":
                            var valueKeyItem = saveItem.argumentsObj.cMapItem?.valueKey;
                            var tagKeyItem = saveItem.argumentsObj.cMapItem?.tagKey;
                            postData = dataList.data.map((row, index) => { return { id: row[dataList.rowId], value: row[valueKeyItem] || "", tag: row[tagKeyItem] || "" } });
                            break;
                        default: break;
                    }
                }

                Object.keys(saveItem.argumentsObj).forEach((key) => {
                    var valueArgs = saveItem.argumentsObj[key];
                    if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                    else args[key] = valueArgs;
                    if (valueArgs === "listValues") args[key] = postData;
                });

                var url = "../" + saveItem.argumentsObj.url;

                console.debug(args);
                //return;//TEMP
                commonFunc.postMethod(url, args).then((response) => {
                    var dataSave = response.data;
                    if (dataSave) {
                        if (dataSave.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: (t(data.subType + "_success") === (data.subType + "_success") ? t("gal_success") : t(data.subType + "_success")),
                                html: (t(data.subType + "_successUpd") === (data.subType + "_successUpd") ? t("gal_successUpd") : t(data.subType + "_successUpd")),
                                didOpen: () => { Swal.hideLoading() },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                if (saveItem.argumentsObj.loadResult && dataSave.extraInfo?.result) {
                                    loadDataRows(dataSave.extraInfo?.result);
                                }
                                else {
                                    getListData(dataList?.data?.length ? dataList.data[0].statusID : 0);
                                }
                            });

                        }
                        else {
                            var supErrors = "";
                            if (dataSave.errors && dataSave.errors.length) {
                                supErrors = dataSave.errors.map((error) => {
                                    return "<br>" + error.desc + "(" + error.value + ")";
                                });
                            }
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorUpd") + " :<br>" + dataSave.errorMessage + supErrors,
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorUpd"),
                            didOpen: () => { Swal.hideLoading() },
                        });
                    }
                });
            }
            else {
                if (!saveItem) {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_errorCfg"),
                        didOpen: () => { Swal.hideLoading() },
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_invalidArgs")
                    });
                }
            }
        };

        if (saveItem && saveItem.argumentsObj && saveItem.argumentsObj.unconfirmProcess) {
            saveProcess();
        }
        else {
            Swal.fire({
                icon: "question",
                title: t(data.subType + savePath + "_updListTitle") === (data.subType + savePath + "_updListTitle") ? t(data.subType + "_updListTitle") : t(data.subType + savePath + "_updListTitle"),
                html: t(data.subType + savePath + "_updListTitle2") === (data.subType + savePath + "_updListTitle2") ? t(data.subType + "_updListTitle2") : t(data.subType + savePath + "_updListTitle2"),
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: t("gal_yes"),
                cancelButtonText: t("gal_no"),
            }).then((result) => {
                if (result.value) {
                    saveProcess();
                }
            });
        }
    }

    function removeList() {
        var removeItem = systemItem[rmvListCptPath];
        var removeProcess = function () {
            Swal.fire({
                title: t("gal_removing"),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            var args = {};
            if (removeItem && removeItem.argumentsObj && Object.keys(removeItem.argumentsObj).length) {
                var dataList = dtFunctions["tableGen" + data.subType].getData(removeItem.argumentsObj.onlySelected);

                var postData = dataList.data;
                if (!commonFunc.isBlank(removeItem.subType)) {
                    switch (removeItem.subType) {
                        case "keyItem":
                            postData = dataList.data.map((row, index) => { return { id: row[dataList.rowId], value: "", tag: "" } });
                            break;
                        default: break;
                    }
                }

                Object.keys(removeItem.argumentsObj).forEach((key) => {
                    var valueArgs = removeItem.argumentsObj[key];
                    if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                    else args[key] = valueArgs;
                    if (valueArgs === "listValues") args[key] = postData;
                });

                var url = "../" + removeItem.argumentsObj.url;

                console.debug(args);
                //return;//TEMP
                commonFunc.postMethod(url, args).then((response) => {
                    var dataSave = response.data;
                    if (dataSave) {
                        if (dataSave.isSuccess) {
                            Swal.fire({
                                icon: "success",
                                title: (t(data.subType + "_success") === (data.subType + "_success") ? t("gal_success") : t(data.subType + "_success")),
                                html: (t(data.subType + "_successRmv") === (data.subType + "_successRmv") ? t("gal_successRmv") : t(data.subType + "_successRmv")),
                                didOpen: () => { Swal.hideLoading() },
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                            }).then((result) => {
                                getListData();
                            });

                        }
                        else {
                            var supErrors = "";
                            if (dataSave.errors && dataSave.errors.length) {
                                supErrors = dataSave.errors.map((error) => {
                                    return "<br>" + error.desc + "(" + error.value + ")";
                                });
                            }
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorRmv") + " :<br>" + dataSave.errorMessage + supErrors,
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorRmv"),
                            didOpen: () => { Swal.hideLoading() },
                        });
                    }
                });
            }
            else {
                if (!removeItem) {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_errorCfg"),
                        didOpen: () => { Swal.hideLoading() },
                    });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        html: t("gal_invalidArgs")
                    });
                }
            }
        };

        if (removeItem && removeItem.argumentsObj && removeItem.argumentsObj.unconfirmProcess) {
            removeProcess();
        }
        else {
            Swal.fire({
                icon: "question",
                title: t("gal_rmvTitle"),
                html: t(data.subType + "_rmvListTitle"),
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                confirmButtonText: t("gal_yes"),
                cancelButtonText: t("gal_no"),
            }).then((result) => {
                if (result.value) {
                    removeProcess();
                }
            });
        }
    }
    function loadStatusBtnGrp() {
        setListStatus([]);

        var args = {};
        var getstatusItem = systemItem[getStatusCptPath];
        if (getstatusItem && getstatusItem.argumentsObj && Object.keys(getstatusItem.argumentsObj).length) {
            Swal.fire({
                title: t("gal_loading"),
                didOpen: () => { Swal.showLoading() },
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
            });

            Object.keys(getstatusItem.argumentsObj).forEach((key) => {
                var valueArgs = getstatusItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + getstatusItem.argumentsObj.url;
            commonFunc.getMethod(url, args).then((response) => {

                if (response.data) {
                    if (response.data.isSuccess) {

                        Swal.close();
                        setListStatus(response.data.result);
                        setCurStatus(getstatusItem.argumentsObj.defaultStatus);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(data.subType + "_errorGetstatus") + " :<br>" + response.data.errorMessage
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t(data.subType + "_errorGetstatus")
                    });
                }
            });
        }
        else {
            if (!getstatusItem) {
                /*Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_errorCfg")
                });*/
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    didOpen: () => { Swal.hideLoading() },
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    function getData(idElem) {
        return new Promise((resolve, reject) => {
            var id = idElem;
            if (id > 0) {
                Swal.fire({
                    title: t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                });

                var args = {};
                var getItem = systemItem[getCptPath];
                if (getItem && getItem.argumentsObj && Object.keys(getItem.argumentsObj).length) {
                    Object.keys(getItem.argumentsObj).forEach((key) => {
                        var valueArgs = getItem.argumentsObj[key];
                        if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                        else args[key] = valueArgs;
                    });

                    var url = "../" + getItem.argumentsObj.url;
                    commonFunc.getMethod(url, args).then((response) => {

                        if (response.data) {
                            if (response.data.isSuccess) {

                                Swal.close();

                                resolve(response.data);
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    didOpen: () => { Swal.hideLoading() },
                                    html: t(data.subType + "_errorGet") + " :<br>" + response.data.errorMessage
                                });
                                resolve({ isSuccess: false, result: (t(data.subType + "_errorGet") + " :<br>" + response.data.errorMessage) });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                didOpen: () => { Swal.hideLoading() },
                                html: t(data.subType + "_errorGet")
                            });
                            resolve({ isSuccess: false, result: t(data.subType + "_errorGet") });
                        }
                    });
                }
                else {
                    if (!getItem) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t("gal_errorCfg")
                        });
                        resolve({ isSuccess: false, result: t("gal_errorCfg") });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t("gal_invalidArgs")
                        });
                        resolve({ isSuccess: false, result: t("gal_invalidArgs") });
                    }
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidID")
                });
                resolve({ isSuccess: false, result: t("gal_invalidID") });
            }
        });
    }

    function saveData(idElem, rowData, forcedCreate) {
        if (disabled) return;
        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        var currData = rowData;

        //Traitement des informations retourné par le Dialog
        var callbackModal = function (dataElem, isUpdate) {
            return new Promise((resolve, reject) => {
                if (dataElem) {
                    Swal.fire({
                        title: t("gal_saving"),
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    dataElem[secondaryKey] = isUpdate ? currData[secondaryKey] : 0;

                    var saveItem = isUpdate ? systemItem[updCptPath] : (systemItem[addSupCptPath] || systemItem[addCptPath]);
                    if (saveItem && saveItem.argumentsObj && Object.keys(saveItem.argumentsObj).length) {
                        var url = "../" + saveItem.argumentsObj.url;

                        if (!dataElem.avoidMerge) {
                            if (currData && currData.hasOwnProperty("custom")) {
                                dataElem = commonFunc.mergeDeep({}, currData.custom, dataElem);
                                dataElem.idEntity = currData.custom ? currData.custom.idEntity : 0;
                            }
                            else {
                                dataElem = commonFunc.mergeDeep({}, currData, dataElem);
                            }

                            dataElem.status = null;
                            dataElem.category = null;
                            dataElem.custom = null;
                            dataElem.parent = null;
                            dataElem.site = null;
                            dataElem.extraSite = null;
                            dataElem.client = null;
                            dataElem.material = null;//Patch Upd Contact
                            dataElem.employee = null;//Patch Upd Contract
                            dataElem.report = null;//Patch Upd Contract
                            dataElem.lead = null;//Patch Upd Contract
                            dataElem.ticket = null;//Patch Upd Contract
                            dataElem.service = null;//Patch Upd Contract
                        }

                        console.debug(dataElem);
                        //return new Promise((resolve, reject) => { resolve({ isSuccess: false }); });//TEMP
                        commonFunc.postMethod(url, dataElem).then((response) => {
                            var dataSave = response.data;
                            if (dataSave) {
                                if (dataSave.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: t("gal_success"),
                                        html: t("gal_success" + (isUpdate ? "Upd" : "Add")),
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        getListData(currData?.statusID);
                                    });

                                    //dataSave.result.idResponse = dataSave.result[secondaryKey];
                                    //resolve(dataSave.result);
                                    dataElem[secondaryKey] = dataSave.result;
                                    dataElem.idResponse = dataSave.result;
                                    resolve(dataElem);

                                    modalRoot.unmount();
                                }
                                else {
                                    var supErrors = "";
                                    if (dataSave.errors && dataSave.errors.length) {
                                        supErrors = dataSave.errors.map((error) => {
                                            return "<br>" + error.desc + "(" + error.value + ")";
                                        });
                                    }
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: t("gal_error" + (isUpdate ? "Upd" : "Add")) + " :<br>" + dataSave.errorMessage + supErrors,
                                        didOpen: () => { Swal.hideLoading() },
                                    });
                                    resolve(dataSave);
                                }
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    html: t("gal_error" + (isUpdate ? "Upd" : "Add")),
                                    didOpen: () => { Swal.hideLoading() },
                                });
                                resolve();
                            }
                        });
                    }
                    else {
                        if (!saveItem) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_errorCfg"),
                                didOpen: () => { Swal.hideLoading() },
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: t("gal_invalidArgs")
                            });
                        }
                        modalRoot.unmount();
                        resolve();
                    }
                }
                else {
                    modalRoot.unmount();
                    resolve();
                }
            });
        };


        modelFctManager.onActionRequired(data.name, { trigger: "getModel", value: data.argumentsObj.dialogConfig }, data).then(actionResponse => {
            if (actionResponse.isSuccess) {
                var type = systemItem[primKeyCptPath].subType;
                var subType = systemItem[secKeyCptPath].subType;
                var genId = systemItem[primaryKey].defaultValue;



                var supProps = {
                    t: t, configModel: actionResponse.result, appProps: modelFctManager.appProps, checkRights: modelFctManager.checkRights, dataCfg: modelFctManager.dataCfg, getRoutes: modelFctManager.getRoutes,
                    genRef: modalGenManager, genId: genId, genType: type, subType: subType, itemData: data, noScroll: (data.argumentsObj.dialogNoScroll ? true : false), size: data.argumentsObj.dialogSize,
                    forcedCreate: forcedCreate, systemItem: systemItem, modelFctManager: modelFctManager, backdropMode: "static", dlgAddCptPath: dlgAddCptPath, dlgUpdCptPath: dlgUpdCptPath, callback: callbackModal
                };//searchTag
                if (data.argumentsObj.noBackdrop) supProps.backdropMode = false;
                else if (data.argumentsObj.dlgBackdropClose) supProps.backdropMode = true;
                if (data.argumentsObj.dlgClickClose) supProps.clickClose = true;

                if (systemItem[getCptPath] && idElem) {
                    getData(idElem).then((responseData) => {
                        if (responseData.isSuccess) {
                            currData = responseData.result;

                            modalRoot = createRoot(document.createElement('div'));
                            modalRoot.render(<SLGenModal dataElem={currData} title={(currData ? t(data.subType + "_updTitle") : t(data.subType + "_addTitle"))} {...supProps} />);
                        }
                    });
                }
                else {
                    modalRoot = createRoot(document.createElement('div'));
                    modalRoot.render(<SLGenModal dataElem={currData} title={(currData ? t(data.subType + "_updTitle") : t(data.subType + "_addTitle"))} {...supProps} />);
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: actionResponse.errorMessage
                });
            }
        });
    }

    function updateStatus(idElem, rowData) {
        return new Promise((resolve, reject) => {
            var req = { id: idElem };

            var updStatus = systemItem[updStatusCptPath];
            if (updStatus?.argumentsObj?.statusObj) {
                req.newStatus = updStatus.argumentsObj.statusObj[rowData.statusID];

                var updStatusT = data.subType + "_updStatus";
                var updStatusI18n = t(updStatusT, { statusName: ">>" }, ">>");
                var updStatusTitle = data.subType + "_updStatusTitle";
                var updStatusTitleI18n = t(updStatusTitle, { statusName: ">>" }, ">>");
                // /!\ Impossible de reposer sur listStatus car le render des boutons DT n'ont pas un accès au state correct...
                /*if (listStatus?.length) {
                    var newStatusObj = listStatus.filter(status => status.idStatus === parseInt(req.newStatus));
                    if (newStatusObj.length) {
                        updStatusI18n = t(updStatusT, { statusName: newStatusObj[0].name }, ">>");
                        updStatusTitleI18n = t(updStatusTitle, { statusName: newStatusObj[0].name }, ">>");
                    }
                }
                else */if (document.querySelector("#st_" + req.newStatus + " label")?.textContent) {
                    var label = document.querySelector("#st_" + req.newStatus + " label").textContent;
                    updStatusI18n = t(updStatusT, { statusName: label }, ">>");
                    updStatusTitleI18n = t(updStatusTitle, { statusName: label }, ">>");
                }


                Swal.fire({
                    icon: "question",
                    title: updStatusI18n !== updStatusT ? updStatusI18n : t("gal_updStatus"),
                    html: updStatusTitleI18n !== updStatusTitle ? updStatusTitleI18n : t("gal_updStatusTitle"),
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: t("gal_yes"),
                    cancelButtonText: t("gal_no"),
                }).then((result) => {
                    if (result.value) {
                        Swal.fire({
                            title: t("gal_updatingStatus"),
                            didOpen: () => { Swal.showLoading() }
                        });

                        if (updStatus.argumentsObj.statusObj.tag) req.tag = updStatus.argumentsObj.statusObj.tag;
                        if (req.newStatus) {

                            var url = "../" + updStatus.argumentsObj.url;
                            commonFunc.postMethod(url, req).then((response) => {
                                Swal.close();
                                if (response.data && response.data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: t("gal_success"),
                                        html: t("gal_successUpd"),
                                        didOpen: () => { Swal.hideLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    }).then((result) => {
                                        getListData(rowData.statusID);
                                    });
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: t("gal_failSaveStatus"),
                                        didOpen: () => { Swal.hideLoading() },
                                    });
                                }
                                resolve(response.data);
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                didOpen: () => { Swal.hideLoading() },
                                html: t("gal_invalidStatus")
                            });
                            resolve({ isSuccess: false, result: t("gal_invalidStatus") });
                        }
                    }
                    else {
                        resolve({ isSuccess: true, result: "" });
                    }
                });
            }
            else {
                if (!updStatus) {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t("gal_errorCfg")
                    });
                    resolve({ isSuccess: false, result: t("gal_errorCfg") });
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t("gal_invalidArgs")
                    });
                    resolve({ isSuccess: false, result: t("gal_invalidArgs") });
                }
            }
        });
    }

    //TODO : Ajout arguments sur ReportItem pour :
    //validation (0, 1 >> validation classique, 2 >> validation par code)
    //permanent (suppression permanente ou non)
    function removeData(id, rowData) {
        return new Promise((resolve, reject) => {
            if (disabled) { resolve({ isSuccess: false, result: t("gal_disabledComponent") }); return; }
            var row = rowData;
            var title = "";
            if ((!id && row) || (id && row && id === row[secondaryKey])) {
                id = id || row[secondaryKey];
                title = (row.name || "") + " " + (row.firstName || "");
            }
            if (parseInt(id) > 0) {
                var removeItem = systemItem[rmvCptPath];
                if (removeItem?.argumentsObj && Object.keys(removeItem.argumentsObj).length) {
                    Swal.fire({
                        icon: "question",
                        title: t("gal_rmvTitle"),
                        html: t(data.subType + "_rmvTitle") + "<br/>[" + id + "] " + title,
                        showCancelButton: true,
                        confirmButtonColor: "#28a745",
                        cancelButtonColor: "#dc3545",
                        confirmButtonText: t("gal_yes"),
                        cancelButtonText: t("gal_no"),
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: t("gal_removing"),
                                didOpen: () => { Swal.showLoading() }
                            });
                            var args = { id: id };

                            Object.keys(removeItem.argumentsObj).forEach((key) => {
                                var valueArgs = removeItem.argumentsObj[key];
                                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                else args[key] = valueArgs;
                            });

                            var url = "../" + removeItem.argumentsObj.url;
                            commonFunc.postMethod(url, args).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    getListData(rowData.statusID);
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: t("gal_errorRmv") + "<br/>" + response.data.errorMessage
                                    });
                                }
                                resolve(data);
                            });

                        }
                        else {
                            resolve({ isSuccess: true, result: "" });
                        }
                    });
                }
                else {
                    if (!removeItem) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_errorCfg")
                        });
                        resolve({ isSuccess: false, result: t("gal_errorCfg") });
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_invalidArgs")
                        });
                        resolve({ isSuccess: false, result: t("gal_invalidArgs") });
                    }
                }
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidID")
                });
                resolve({ isSuccess: false, result: t("gal_invalidID") });
            }
        });
    }

    function showFlows(idElem, rowData) {
        if (disabled) { return; }
        if (modalRoot) {
            modalRoot.unmount();
            modalRoot = null;
        }

        if (parseInt(idElem) > 0) {
            //Traitement des informations retourné par le Dialog
            var callbackModal = function (dataElem, isUpdate) {
                modalRoot.unmount();
            };

            //setValue(secondaryKey, idElem);
            if (!systemItem[secondaryKey]) systemItem[secondaryKey] = {};
            systemItem[secondaryKey].defaultValue = idElem;

            modalRoot = createRoot(document.createElement('div'));
            modalRoot.render(<FlowsModal t={t} itemData={data} title={t(data.subType + "_flowsTitle")} idElem={idElem} rowData={rowData}
                parentContext={{ getData: getData, systemItem: systemItem, modelFctManager: modelFctManager, parentProps: parentProps, flowsCptPath: flowsCptPath, getCptPath: getCptPath }} callback={callbackModal} />);

        }
        else {
            Swal.fire({
                icon: "error",
                title: t("gal_error"),
                html: t("gal_invalidID")
            });
        }
    }

    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }

    function datepickerChange(date, endChange) {
        if (!date) date = moment(curDate);

        if (!endChange) setCurDate(date.format());
        else setEndDate(date.format());
    }



    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin) {
            //setCurDate(begin.startOf('day').format());
            setCurDate(begin.utc(true).startOf('day').format());
        }
    }
    
    function getFormattedDate() {
        switch (curPeriod) {
            case "D": return moment(curDate).format("dddd DD MMMM YYYY");
            case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
            case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
            case "M": return moment(curDate).startOf('month').format("ddd DD MMMM YYYY") + " au " + moment(curDate).endOf('month').format("ddd DD MMMM YYYY");
            case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
            case "C": return "Saisie Manuelle";
            default: return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/


    //TODO : design
    var frameClass = "";
    var frameStyle = {};
    //var containerClass = "";
    if (data.hidden) {
        if (isConfiguration) {
            frameClass += " config-hidden";
        }
        else {
            frameClass += " d-none";
        }
    }
    if (data.checkRights) {
        var hasRights = modelFctManager.checkRights(data.checkRights.entity, data.checkRights.rights);
        if (!hasRights) frameClass += " d-none";
    }

    //var widthClass = "";
    //var titleWidthClass = "px-0 ";

    var design = data.customDesign?.design;
    design = modelFctManager.prepareMergedDesign(data, design, "default_simpleList");
    data.mergedDesign = design;
    if (design) {
        if (design.boxSize) {
            frameClass += modelFctManager.manageBoxSize("item-" + parentProps?.parentData?.gridID + "-" + data?.key, design.boxSize, data);
        }
        if (design.height) {
            if (parseFloat(design.height.replace("px", "")) >= 0) frameStyle.height = design.height;
            else {
                frameClass += " h-100";
            }
            //frameStyle.overflowY = "hidden";//auto
            //frameClass += " m-0";
        }
    }

    var rightsObj = systemItem[saveListCptPath];
    var saveListRights = true;
    if (rightsObj && rightsObj.checkRights) {
        saveListRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem[rmvListCptPath];
    var removeListRights = true;
    if (rightsObj && rightsObj.checkRights) {
        removeListRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem[addCptPath];
    var addRights = true;
    if (rightsObj && rightsObj.checkRights) {
        addRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }

    var searchTag = "";
    var markClass = "";
    if (data.argumentsObj.cSearchParams) {
        searchTag = getValues(commonFunc.camelize(data.argumentsObj.cSearchParams, true)) || "";
        markClass = data.argumentsObj.cMarkClass || "";
    }

    var childAltDisplay = data.argumentsObj?.cAltDisplay;
    var altConfigs = {};
    if (data.argumentsObj?.cPeriods) altConfigs.cPeriods = data.argumentsObj?.cPeriods;
    if (!data.argumentsObj?.cNoPeriods) altConfigs.updatePeriod = setCurPeriod;

    var baseForm = <>
        <div className="clearfix">
            {systemItem[getListCptPath]?.argumentsObj?.cUseToolbarDate ?
                <ToolbarDate refreshContent={getListData} customTitle={getFormattedDate()/*this.state.curDate.toLocaleString("fr-FR", { month: "long" })*/} hideRefresh={true}
                    currentPeriod={curPeriod}
                    selPreviousPeriod={selPreviousPeriod}
                    datepickerChange={datepickerChange}
                    selNextPeriod={selNextPeriod}
                    datepickerOpt={{ showWeeks: true, initialValue: moment(new Date()).utc().toDate(), initialEndValue: moment().endOf("year").endOf("day").toDate() }}
                    customAddBtn={<div className="d-none"></div>} {...altConfigs}></ToolbarDate>
                : ""}

            <div className={`float-start ${childAltDisplay ? "d-flex" : ""}`} >
                {systemItem[getListCptPath] && !(systemItem[getListCptPath]?.argumentsObj?.cHideButton) ?
                    (<Button className="btn-rotate px-2 mt-0 btn-simple" color="dark" size="sm" onClick={() => {
                        var getlistItem = systemItem[getListCptPath];
                        if (getlistItem?.argumentsObj?.useProp) {
                            modelFctManager.onActionRequired(data.name, { trigger: "refreshElem" }, data).then(actionResponse => {
                                if (actionResponse.isSuccess) {
                                    //getListData();
                                }
                                else {
                                    Swal.fire({
                                        icon: "error",
                                        title: t("gal_error"),
                                        html: actionResponse.errorMessage
                                    });
                                }
                            });
                        }
                        else {
                            getListData();
                        }
                    }}>
                        <i className="fa fa-sync"></i>{altT(systemItem[getListCptPath].title) || t(data.subType + "_refresh")}
                    </Button>)
                    : ""}
                {!exclusionStatus && systemItem[saveListCptPath] && saveListRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="primary" size="sm" onClick={() => { saveList() }}>
                    <i className="fa fa-save"></i>{altT(systemItem[saveListCptPath].title) || t(data.subType + "_saveList")}
                </Button> : ""}
                {!exclusionStatus && systemItem[rmvListCptPath] && removeListRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="danger" size="sm" onClick={() => { removeList() }}>
                    <i className="fa fa-times"></i>{altT(systemItem[rmvListCptPath].title) || t(data.subType + "_removeList")}
                </Button> : ""}
                {!exclusionStatus && systemItem[addCptPath] && addRights ? <Button className="btn-magnify px-2 mt-0" disabled={disabled} color="success" size="sm" onClick={() => { saveData() }}>
                    <i className="fa fa-plus"></i>{altT(systemItem[addCptPath].title) || t(data.subType + "_add")}
                </Button> : ""}
                <div className="d-inline-block" style={{ marginTop: (childAltDisplay ? "0px" : "-10px"), maxWidth:"950px" }}>
                    <div className="row m-0">
                        {data.children ? data.children.map((child) => {
                            return modelFctManager.componentTyped(child, parentProps);
                        }) : ""}
                    </div>
                </div>
            </div>
            {systemItem[getStatusCptPath] && !(systemItem[getStatusCptPath].argumentsObj?.cHideButton) ? <CNavbar className="float-end">
                <div className="text-end">
                    {listStatus.map((dt) => {
                        var statusClass = "form-badge-radio mb-1 ";
                        statusClass += dt.css ? dt.css.replace("fa-", "untrigger") : "";
                        return dt.isSchedulable ? <div id={`st_${dt.idStatus}`} key={dt.idStatus} className={statusClass}>
                            <div className='form-check-radio fcheck-sm mb-0'>
                                <Label check >
                                    <Input id={`status_${dt.idStatus}`} name={"status"} /*disabled={this.state.editionMode}*/ checked={dt.idStatus === curStatus} type="radio" data-lvlv={dt.step} value={dt.idStatus} onChange={(e) => {
                                        var value = parseInt(e.target.value);
                                        setCurStatus(value);
                                    }} />
                                    <span className="form-check-sign" />
                                    {(() => {
                                        var classFa = "";
                                        if (dt.css && dt.css.indexOf("fa-")) {
                                            dt.css.split(" ").forEach((classElem) => {
                                                //console.debug(classElem.startsWith("fa-") + classElem);
                                                classFa += (classElem.startsWith("fa-") ? (classElem + " ") : "");
                                            });
                                        }
                                        return <i className={`fa ${classFa} me-1`}></i>
                                    })()}
                                    {dt.name}
                                </Label>
                            </div>
                        </div> : "";
                    })}
                </div>
            </CNavbar> : ""}
            <div id={data.subType + "_select_filters"} className="d-none w-auto p-0">
                {data.options ? data.options.map((optionSelect, indexSelect) => {
                    return <div key={indexSelect} className="d-inline-block">
                        <Label className={`px-0 m-0 d-inline-block mx-2`} for={"select" + indexSelect}>{optionSelect.title}</Label>
                        <Input id={"select" + indexSelect} bsSize="sm" className={`w-auto d-inline-block`} type="select" disabled={disabled} style={{ maxWidth: (optionSelect.customDesign?.design?.maxWidth ? optionSelect.customDesign?.design?.maxWidth : "") }} onChange={(e) => {
                            var selValue = (e.target.value === "true" ? true : (e.target.value === "false" ? false : e.target.value));
                            var getlistItem = systemItem[getListCptPath];
                            if (getlistItem?.argumentsObj && optionSelect.defaultValue) {
                                getlistItem.argumentsObj[optionSelect.defaultValue] = selValue;
                                getListData();
                            }
                            else {
                                var filterObj = { value: selValue };
                                if (optionSelect.options) {
                                    var filteredOpt = optionSelect.options.filter(opt => opt.value === e.target.value && opt.format);
                                    if (filteredOpt.length) filterObj.operator = filteredOpt[0].format;
                                }
                                curFilter[optionSelect.value] = filterObj;
                                setCurFilter(curFilter);
                                setFilteredRows(filterData(curFilter));
                                setDataStamp(new Date().getTime());
                            }
                        }}>
                            {(() => {
                                var allOpt = { selected: true, title: "Tous", value: -1 };
                                var options = [];

                                if (optionSelect.options) {
                                    options = optionSelect.options;
                                }
                                else {
                                    //TODO : alimenter les options avec les data
                                    allOpt.value = "";

                                    var values = {};
                                    dataRows.forEach((row) => {
                                        var value = commonFunc.getValue(row, optionSelect.value);
                                        if (value && !values[value]) {
                                            values[value] = value;
                                            options.push({ title: value, value: value });
                                        }
                                    });
                                }

                                if (optionSelect.format === "orderString") options = options.sort((a, b) => a.title.localeCompare(b.title));
                                if (!optionSelect.options) options.unshift(allOpt);

                                return options.map((option, index) => {
                                    return <option className={`${option.hidden ? "d-none" : ""}`} key={index} selected={option.selected} value={option.value}>
                                        {option.customDesign?.design?.icon ? <i className={`fa ${option.customDesign.design.icon}`}></i> : ""}
                                        {option.title}
                                    </option>
                                });
                            })()}
                        </Input>
                    </div>
                }) : ""}
            </div>
        </div>
        {data.argumentsObj.cSwitchWidget ? <div className="clearfix d-flex">
            <div className="float-start flex-fill"><Button className="btn-icon btn-round" color="primary" onClick={() => {
                data.objType = "widgetList";
                data.key = 0;
                if (!data.onActionEvents) data.onActionEvents = {};
                data.onActionEvents.onLoad = (data.onActionEvents?.onLoad?.filter((event) => !(event.trigger === "updateDataStamp" && event.contextType === "autoDisplay")) || []);
                data.onActionEvents.onLoad.push({ trigger: "updateDataStamp", contextType: "autoDisplay" });
                parentProps?.parentData?.functionManager.rerender(true);
            }}><i className="fa fa-table" title={t("gal_switchDisplay")} ></i></Button></div>
        </div> : ""}
        {dtModel ? <CDataTable key={"gen" + data.subType} dtId={"tableGen" + data.subType} data={filteredRows} localConfig={dtConfig} tag={data.argumentsObj.dtConfig} config={dtModel} stamp={dataStamp} attrSup={{ "dt-filter-target": (data.subType + "_select_filters") }}
            functionPanel={dtFunctionPanel} searchParams={searchTag} markClass={markClass} className={`table-striped table-hover nowrap`} style={{ fontSize: "90%" }} /> : ""}
    </>;

    if (data.argumentsObj.sidebarMini) document.body.classList.add("sidebar-mini");
    if (data.argumentsObj.sidebarLocked) document.body.classList.add("sidebar-locked");

    return <Col data-name="SimpleListGeneric" data-element={data.objType} xs="auto" className={`${frameClass} ${parentProps.parentData.customDesign?.design?.spacing ? "" : "p-0"}`} style={frameStyle}>{baseForm}</Col>;//align-self-center
}


function SLGenModal({ t, title, configModel, dataCfg, appProps, checkRights, getRoutes, genRef, genId, genType, subType, itemData, noScroll, size, dataElem, forcedCreate, systemItem, modelFctManager, backdropMode, clickClose, dlgAddCptPath, dlgUpdCptPath, callback }) {
    //Vérification de droits spécifiques à l'affichage des boutons dialog
    var rightsObj = systemItem[dlgAddCptPath];
    var addRights = true;
    if (rightsObj?.checkRights) {
        addRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }
    rightsObj = systemItem[dlgUpdCptPath];
    var updRights = true;
    if (rightsObj?.checkRights) {
        updRights = modelFctManager.checkRights(rightsObj.checkRights.entity, rightsObj.checkRights.rights);
    }

    var supProps = {};
    if (clickClose) supProps.onClick = (e) => { console.debug(e.target.nodeName); if (e.target.nodeName !== "BUTTON" && e.target.parentElement.nodeName !== "BUTTON") callback(); };

    return (
        <Modal isOpen={true} className={`modal-${itemData.subType} ${noScroll ? "modal-noscroll" : ""}`} size={size ? size : "xxl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static"
            style={{ paddingTop: "0px" }} {...supProps}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={noScroll ? { overflow: "visible" } : { overflowX: "hidden" }}>
                <AGenerateModel ref={genRef} noButtons onSubmit={(data, isUpdate) => callback(data, isUpdate)} appProps={appProps} checkRights={checkRights} getRoutes={getRoutes} parentProps={{ id: genId, type: genType, subType: subType, dataCfg: dataCfg }} keyMode={2} configModel={configModel} loadedData={dataElem} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {
                    (dataElem && !forcedCreate) ? <Button className={`px-3 ${addRights ? "" : "d-none"}`} color="primary" onClick={() => {
                        var generateModel = genRef.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm(true);
                        }
                    }}><i className="fa fa-edit"></i>{t("gal_edit")}</Button> : <Button className={`px-3 ${updRights ? "" : "d-none"}`} color="success" onClick={() => {
                        var generateModel = genRef.current;
                        if (generateModel && generateModel.submitForm) {
                            generateModel.submitForm();
                        }
                        }}><i className="fa fa-plus"></i>{t("gal_add")}</Button>
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_close")}</Button>
            </ModalFooter>
        </Modal>
    );
}

function FlowsModal({ t, title, itemData, noScroll, idElem, rowData, dataFlows, parentContext, callback }) {

    const [flows, setFlows] = React.useState(dataFlows || []);

    var flowsItem = parentContext.systemItem[parentContext.flowsCptPath];

    React.useEffect(() => {
        if (!flowsItem.argumentsObj.componentUrl) {
            initFlows();
        }
    }, []);

    function initFlows() {
        var currData = rowData;

        var args = {};
        if (flowsItem && flowsItem.argumentsObj && Object.keys(flowsItem.argumentsObj).length && flowsItem.argumentsObj.url) {
            Object.keys(flowsItem.argumentsObj).forEach((key) => {
                var valueArgs = flowsItem.argumentsObj[key];
                if (valueArgs.startsWith && valueArgs.startsWith("prop:")) args[key] = (parentContext.systemItem[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                else args[key] = valueArgs;
            });

            var url = "../" + flowsItem.argumentsObj.url;
            commonFunc.getMethod(url, args).then((response) => {

                if (response.data) {
                    if (response.data.isSuccess) {

                        Swal.close();


                        setFlows(response.data.result);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            didOpen: () => { Swal.hideLoading() },
                            html: t(itemData.subType + "_errorGet") + " :<br>" + response.data.errorMessage
                        });
                    }
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: t("gal_error"),
                        didOpen: () => { Swal.hideLoading() },
                        html: t(itemData.subType + "_errorGet")
                    });
                }
            });
        }
        else if (parentContext.systemItem[parentContext.getCptPath] && idElem) {
            parentContext.getData(idElem).then((responseData) => {
                if (responseData.isSuccess) {
                    currData = responseData.result;

                    if (Array.isArray(currData)) {
                        setFlows(currData);
                    }
                    else {
                        setFlows(currData.flows);
                    }
                }
            });
        }
        else if (currData.flows) {
            if (Array.isArray(currData)) {
                setFlows(currData);
            }
            else {
                setFlows(currData.flows);
            }
        }
        else {
            if (!flowsItem) {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_errorCfg")
                });
            }
            else {
                Swal.fire({
                    icon: "error",
                    title: t("gal_error"),
                    html: t("gal_invalidArgs")
                });
            }
        }
    }

    return (
        <Modal isOpen={true} className={`modal-flows ${noScroll ? "modal-noscroll" : ""}`} size="xxl" scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <Historical type="modelFlows" elemId={idElem} rows={flows} url={flowsItem.argumentsObj.componentUrl ? "../" + flowsItem.argumentsObj.componentUrl : ""} getRoutes={parentContext.modelFctManager.getRoutes} shouldRender={true}>
                    {flowsItem.children ? flowsItem.children.map((child) => {
                        return parentContext.modelFctManager.componentTyped(child, parentContext.parentProps);
                    }) : ""}
                </Historical>
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t("gal_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}